










import { Component, Prop, Vue } from 'vue-property-decorator';
import CourseStatus from '@/components/atoms/CourseStatus.vue';
import { DoceboLoEnrolmentStatus } from '@/lib/DoceboAPI';

@Component({
  components: {
    CourseStatus,
  },
})
export default class LearingObject extends Vue {
  @Prop() loName!: string;

  @Prop() loStatus!: DoceboLoEnrolmentStatus;

  @Prop() locked!: null | 'locked';

  private onLearningObjectPressed() {
    if (this.locked) return;
    this.$emit('click');
  }
}
